import unset from 'lodash/unset';
import { getTenureTypeByKey } from '../../../shared/model/constants/tenureType';

export default response => ({
  availableResults: response.availableResults,
  exactMatchListings: response.listings.map((listing) => {
    const { tenureType } = listing.omniture;
    unset(listing, 'omniture.tenureType');
    return ({
      tenureTypeObject: getTenureTypeByKey(tenureType),
      ...listing,
    });
  }),
  surroundingSuburbListings: response.surroundingSuburbListings.map((listing) => {
    const { tenureType } = listing.omniture;
    unset(listing, 'omniture.tenureType');
    return ({
      tenureTypeObject: getTenureTypeByKey(tenureType),
      ...listing,
    });
  }),
  surroundingSuburbTitle: response.surroundingSuburbTitle,
  advertising: response.advertising,
  resolvedLocations: response.resolvedLocations,
});
